import React from 'react'

const InputTodoContext = React.createContext(
    {
        InputTodo: (event: any) => { }
    }
);

export default InputTodoContext;